import React, { Component } from 'react';
import { CSVLink } from 'react-csv';
import Constants from '../../../../shared/constants';
import { IconWrapper, Icon } from '../styles';
import { OrdersListWrapper } from '../../orders/styles';
import GiggerService from '../../../../services/AdminServices/GiggersService';
import Config from '../../../../config';
import LoadingCard from '../../LoadingCard';
import SearchInput from '../../../../components/Input/SearchInput';
import { getFormattedCSVData } from '../../../../shared/utils';
import Pagination from '../../../../components/Pagination/Pagination';
import ListViewHeader from '../../orders/ListView/ListViewHeader';
import ListViewBody from '../../orders/ListView/ListViewBody';

class OrdersTab extends Component {
  giggerService = new GiggerService(Config.apiBase);

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      orderData: [],
      searchbar: true,
      meta: {
        cursor: {
          previous: null,
          current: 0,
          next: 1,
          count: null,
          pageNumber: 1,
          pageSize: 15,
          pages: 1,
        },
      },
      searchQuery: '',
      csvDownloadData: [],
      csvExportFileds: ['user_id', 'company_name', 'company_user_name', 'type', 'created_at', 'amount', 'status'],
    };
  }

  componentDidMount() {
    this.fetchOrders();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      meta: {
        cursor: { pageNumber },
      },
    } = this.state;
    if (prevState && prevState.meta && prevState.meta.cursor.pageNumber !== pageNumber) {
      this.fetchOrders();
    }
  }

  /**
   * Handles pagination
   * @param {Number} pageNumber page number
   */
  handleGotoPage = (pageNumber) => {
    const { meta: { cursor } } = this.state;
    this.setState({
      meta: {
        cursor: {
          ...cursor,
          pageNumber,
        },
      },
    });
  };

  /**
   * Handles search functionality
   * @param {String} value search text
   */
  handlesearchOrders=(value) => {
    this.setState({ searchQuery: value, searchbar: value.length <= 0 }, () => {
      this.fetchOrders(value);
    });
  }

  /**
   * Handles Change in search value
   * @param {Event} event search value
   */
  handleSearchOnChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  /**
   * Dowloads data in the form of csv file
   */
  handleDownloadCsv = async () => {
    this.setState({ loading: true });
    const { giggerId } = this.props;
    const { csvExportFileds } = this.state;
    const queryParams = [
      ['export', true],
      ['exportFields', csvExportFileds.toString()],
    ];
    try {
      const response = await this.giggerService.getGiggerOrders(giggerId, queryParams);
      this.setState({ csvDownloadData: getFormattedCSVData(response.data), loading: false });
      if (response) {
        this.ordersCsv.link.click();
      }
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  /**
   * displays search bar
   */
  openSearchBar = () => {
    this.setState({ searchbar: false });
  };

  /**
   * Loads data
   */
  handleLoad = () => {
    this.fetchOrders();
  };

  /**
   * @async
   * @function fetchOrders Fetches orders
   * @param {String} searchInput search text
   */
  async fetchOrders(searchInput) {
    const { giggerId } = this.props;
    const {
      meta: {
        cursor: { pageNumber, pageSize },
      },
      searchQuery,
    } = this.state;
    this.setState({ loading: true });
    const queryParams = [
      ['pageNumber', searchInput ? 1 : pageNumber],
      ['pageSize', pageSize],
      ['search', searchQuery],
    ];
    try {
      const response = await this.giggerService.getGiggerOrders(giggerId, queryParams);
      this.setState({ loading: false, orderData: response.data, meta: response.meta });
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  render() {
    const {
      searchbar,
      orderData,
      loading,
      csvDownloadData,
      searchQuery,
      meta,
    } = this.state;
    return (
      <>
        <CSVLink
          data={csvDownloadData}
          filename="giggerOrders.csv"
          className="d-none"
          ref={(r) => { this.ordersCsv = r; }}
        >
          click
        </CSVLink>

        <OrdersListWrapper>
          <IconWrapper className="row m-0">
            {searchbar ? (
              <Icon src={Constants.icons.SearchIcon} alt="icon" onClick={this.openSearchBar} />
            ) : (
              <div className="text-end col-auto p-0">
                <SearchInput
                  onSearch={this.handlesearchOrders}
                  onChange={this.handleSearchOnChange}
                  value={searchQuery}
                />
              </div>
            )}
            <Icon
              src={Constants.icons.ExportIcon}
              alt="icon"
              className={orderData && orderData.length > 0 ? 'mr-3' : 'disableOption mr-3'}
              onClick={this.handleDownloadCsv}
            />
          </IconWrapper>
          {loading && (
            <OrdersListWrapper>
              <LoadingCard />
            </OrdersListWrapper>
          )}
          {!loading && (
            <>
              <ListViewHeader gigger />
              <ListViewBody gigger handleLoad={this.handleLoad} data={orderData} />
            </>
          )}
        </OrdersListWrapper>
        {!loading && meta.cursor.pages > 1 && (
        <OrdersListWrapper className="bg-transparent.">
          <Pagination cursor={meta.cursor} gotoPage={this.handleGotoPage} />
        </OrdersListWrapper>
        )}
      </>
    );
  }
}

export default OrdersTab;
